import { useCustomerConfiguration } from 'src/easyclaim.app.contexts/CustomerConfigurationContextCore';

/**
 * Whether this customer is allowed to use the easyclaim.app experimental performance
 * enhancer (new tanstack-query/zustand based upload+thumbnail flow), driven by the
 * `canUseExperimentalPerformanceEnhancer` flag on the customer's configuration.
 */
export function useIsPerformanceEnhancerEnabled(): boolean {
	const configuration = useCustomerConfiguration();

	return configuration?.canUseExperimentalPerformanceEnhancer ?? false;
}
